import React from 'react';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TableProps, PaginationProps } from 'antd';

interface PaginatedTableProps<RecordType> extends TableProps<RecordType> {
    total: number;
    current: number;
    pageSize: number;
    rowKey?: string;
    onPaginationChange?: PaginationProps['onChange'];
    onPageSizeChange?: PaginationProps['onShowSizeChange'];
    onRow?: TableProps<RecordType>['onRow'];
    rowSelection?: TableProps<RecordType>['rowSelection'];
}

function PaginatedTable<RecordType extends object>({
    dataSource,
    columns,
    scroll = { x: 1200 },
    rowKey = 'id',
    onChange,
    total,
    current,
    pageSize,
    pagination,
    onPaginationChange,
    onPageSizeChange,
    onRow,
    rowSelection,
    ...rest
}: PaginatedTableProps<RecordType>) {
    const { t } = useTranslation();

    return (
        <Table<RecordType>
            dataSource={dataSource}
            columns={columns}
            scroll={scroll}
            rowKey={rowKey}
            onChange={onChange}
            onRow={onRow}
            rowSelection={rowSelection}
            pagination={{
                ...pagination,
                total,
                current,
                pageSize,
                showSizeChanger: true,
                onChange: onPaginationChange,
                onShowSizeChange: onPageSizeChange,
                position: ['topLeft', 'bottomLeft'],
                showTotal: (total, range) => (
                    <>
                        {t('PaginateTotal')} <strong>{total}</strong> {t('PaginateRegisters')}
                    </>
                ),
            }}
            {...rest}
        />
    );
}

export default PaginatedTable;
